module.exports = __webpack_public_path__ + "7daa2e6a04c4753f26d87efe15a58006.gif";